export function chatMessageRelationFilter(identifier) {
    const value = typeof identifier === "object"
        ? identifier?.documentId ?? identifier?.id
        : identifier;
    return /^\d+$/.test(String(value || ""))
        ? {id: {$eq: Number(value)}}
        : {documentId: {$eq: value}};
}

// Conversation header filters (spec section 4): messages with files or with a linked task / project / goal.
export const CHAT_MESSAGE_KINDS = ["files", "task", "project", "goal"];

// linkedEntity is JSON; MySQL renders it as {"type": "task"} and MariaDB keeps {"type":"task"}, so match both.
function linkedTypeFilter(type) {
    return {$or: [
        {linkedEntity: {$containsi: `"type": "${type}"`}},
        {linkedEntity: {$containsi: `"type":"${type}"`}},
    ]};
}

export function hasChatMessageFilters({search = "", kind = null, since = null, until = null} = {}) {
    return Boolean(String(search || "").trim() || CHAT_MESSAGE_KINDS.includes(kind) || since || until);
}

export function buildChatMessagePageQuery(chatIdentifier, populate, {page = 1, pageSize = 40, search = "", kind = null, since = null, until = null} = {}) {
    const andFilters = [{chat: chatMessageRelationFilter(chatIdentifier)}];
    const normalizedSearch = String(search || "").trim();
    if (normalizedSearch) {
        andFilters.push({messageContent: {$containsi: normalizedSearch}});
    }
    if (kind === "files") andFilters.push({attachment: {id: {$notNull: true}}});
    else if (CHAT_MESSAGE_KINDS.includes(kind)) andFilters.push(linkedTypeFilter(kind));
    if (since) andFilters.push({createdAt: {$gte: new Date(since).toISOString()}});
    if (until) andFilters.push({createdAt: {$lte: new Date(until).toISOString()}});

    return {
        filters: {$and: andFilters},
        populate,
        sort: ["sentAt:desc", "createdAt:desc"],
        pagination: {page, pageSize, withCount: true},
    };
}
